// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4fc1b0bc","239":"3b2a58b4","455":"2291991b"}[chunkId] + ".chunk.js";
};